import { IProductVariant } from '@models/IProductVariant';
import updateDataLayer from '@utils/helpers/gtm';
import classNames from 'classnames';
import { motion } from 'framer-motion';
import { useState } from 'react';

interface Props {
  currentSkuCode?: string;
  displayTags?: boolean;
  small?: boolean;
  variations?: IProductVariant[];
  dataTestId?: string;
}

const ColourSwatch = ({
  currentSkuCode,
  displayTags = false,
  small = false,
  variations,
  dataTestId = 'Colour-Swatch',
}: Props) => {
  const [activeIndex, setActiveIndex] = useState(-1);

  return (
    <div
      className={classNames(
        small ? 'gap-0' : 'gap-3 md:gap-2',
        'flex flex-row'
      )}
      data-testid={dataTestId}
    >
      {variations
        ?.filter((variation) => variation.colour)
        .map(({ name, url, colour, skuCode }, index) => (
          <a
            onFocus={() => setActiveIndex(index)}
            onBlur={() => setActiveIndex(-1)}
            onMouseEnter={() => setActiveIndex(index)}
            onMouseLeave={() => setActiveIndex(-1)}
            onClick={() =>
              updateDataLayer({
                event: 'productModification',
                content_type: 'color',
                selection: name,
              })
            }
            href={url}
            key={`colour-variation-${colour}`}
            className={classNames(
              'relative flex items-center justify-center rounded-full transition-colors duration-300 ease-in-out hover:border-gray-400',
              {
                'border border-black-100 dark:border-white':
                  skuCode === currentSkuCode || activeIndex === index,
              },
              small
                ? 'h-[18px] w-[18px]'
                : 'h-[27px] w-[27px] md:h-[18px] md:w-[18px]'
            )}
            aria-label={name}
            data-testid={`${dataTestId}-Colour-${index}`}
          >
            <span
              style={{ backgroundColor: colour }}
              className={classNames(
                small
                  ? 'h-[12px] w-[12px]'
                  : 'h-[19px] w-[19px] border border-grey-250 md:h-[12px] md:w-[12px]',
                'rounded-full'
              )}
            />
            {name && displayTags && activeIndex === index && (
              <motion.span
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 0.1 }}
                className="small-text -top-10 -translate-x-1/2 absolute left-1/2 whitespace-nowrap rounded-full bg-white px-2 text-black-100"
                data-testid={`${dataTestId}-Name-${index}`}
              >
                {name}
              </motion.span>
            )}
          </a>
        ))}
    </div>
  );
};

export default ColourSwatch;
